import { observer } from 'mobx-react';
import * as React from 'react';
import ReactModal from 'react-modal';

import { RadioItem } from '../radio-item/radio-item';

ReactModal.setAppElement('#root');

export interface Item<T> {
  id: string;
  selected: boolean;
  value: T;
}

interface SearchableRadioItemSetProps<T> {
  items: Item<T>[];

  label(t: T): string;
  hintText(t: T): string;
  onChange(id: string): void;

}

@observer
export class SearchableRadioItemSet<T> extends React.Component<SearchableRadioItemSetProps<T>> {

  render() {
    return (
      <>
        {Object.values(this.props.items).map(item => {
          return (
            <RadioItem
              size={'xsmall'}
              key={item.id}
              selected={item.selected}
              label={this.props.label(item.value)}
              hintText={this.props.hintText(item.value)}
              onChange={() => this.props.onChange(item.id)}
            />
          );
        })}
      </>
    );;
  }
}



// WEBPACK FOOTER //
// ./src/ui/widgets/searchable-radio-item-set/searchable-radio-item-set.tsx